import create from 'utilities/zustand/create';
import userStorage from 'storage/user';
import { usePostStore } from 'three/Renderer/store';
import { useGpuDetect } from '../GpuDetectService';

export const useQualitySettings = create((set, get) => {
  function makeSetting(modifier) {
    const { renderConfiguration } = usePostStore.getState();
    const copy = JSON.parse(JSON.stringify(renderConfiguration));
    if (modifier) modifier(copy);
    return { renderConfiguration: copy };
  }

  return {
    setting: -1,
    settings: [
      {
        label: 'Eco',
        ...makeSetting(renderConfiguration => {
          renderConfiguration.pixelRatio = 0.8;
          renderConfiguration.maxFps = 30;
          renderConfiguration.maxPixelArea = 1200;
          renderConfiguration.postEnabled = false;
          renderConfiguration.shadow.enabled = false;
          renderConfiguration.shadow.size = 512;
        }),
      },
      {
        label: 'Normal',
        ...makeSetting(renderConfiguration => {
          renderConfiguration.pixelRatio = 1;
          renderConfiguration.maxFps = 60;
          renderConfiguration.maxPixelArea = 2000;
          renderConfiguration.postEnabled = false;
          renderConfiguration.shadow.enabled = false;
          renderConfiguration.shadow.size = 1024;
        }),
      },
      {
        label: 'High',
        ...makeSetting(renderConfiguration => {
          renderConfiguration.pixelRatio = 1.5;
          renderConfiguration.maxFps = 60;
          renderConfiguration.maxPixelArea = 2000;
          renderConfiguration.postEnabled = true;
          renderConfiguration.postMultisampling = 2;
          renderConfiguration.bloom.enabled = true;
          renderConfiguration.shadow.enabled = true;
          renderConfiguration.shadow.size = 2048;
        }),
      },
      {
        label: 'Ultra',
        ...makeSetting(renderConfiguration => {
          renderConfiguration.pixelRatio = 1.5;
          renderConfiguration.maxFps = 200;
          renderConfiguration.maxPixelArea = 4000;
          renderConfiguration.postEnabled = true;
          renderConfiguration.postMultisampling = 4;
          renderConfiguration.bloom.enabled = true;
          renderConfiguration.shadow.enabled = true;
          renderConfiguration.shadow.size = 4096;
        }),
      },
    ],
    options: [],
    init: () => {
      const { tier, isMobile } = useGpuDetect.getState();
      const defaultOptionIndex = tier <= 2 ? 0 : 1;
      userStorage.initQualitySetting(defaultOptionIndex);

      const { settings } = get();
      const options = settings.reduce((acc, s) => {
        acc.push({ ...s, selected: false, default: false });
        return acc;
      }, []);

      const selectedOption = options[userStorage.getQuality()];
      selectedOption.selected = true;

      const defaultOption = options[defaultOptionIndex];
      defaultOption.default = true;

      usePostStore.getState().set(selectedOption.renderConfiguration);
      set({ options });
    },

    changeQualityOption: index => {
      userStorage.setQuality(index);
      const options = get().options.map((o, i) => {
        return { ...o, selected: i === index };
      });
      const selectedOption = options.find(o => o.selected);
      usePostStore.getState().set(selectedOption.renderConfiguration);
      set({ options });
    },
  };
});
